import { StoreType } from "@reducers/types";
import { FamilyState } from "@reducers/types/HRM/family-state";

export const getFamilyState = (state: StoreType): FamilyState =>
  state.hrm.employee.familyInfo;
